<template>
   <footer>
      <div>
         <img src="../../../../assets/icons/logos/aepc.jpg">
         <img src="../../../../assets/icons/logos/giz.jpg">
         <img style="margin: 0 7px 0 7px;" src="../../../../assets/icons/logos/combinedLogo.png">
         <img class='pathway' src="../../../../assets/icons/logos/ptas-logo.png">
      </div>
   </footer>
</template>

<script>
export default {
   name: 'org-footer',
}
</script>

<style lang="scss" scoped>
footer div {
   width: 100%;
   text-align: center;
   font-family: $primary-font;
   background-color: white;
   display: flex;
   justify-content: flex-end;
   img {
      height: 2.5em;
   }
   .pathway {
      padding: 0.2em 0;
   }
}
</style>